import { useSelector } from "react-redux";
import { getGameSettings } from "../../redux/slices/gameSettingsSlice";

const useGameSettings = () => {
    // Access game settings from Redux store
    const gameSettings = useSelector(getGameSettings);

    // Extract necessary properties
    const lines = gameSettings?.slotConfigDetails?.lines || 0;
    const reels = gameSettings?.slotConfigDetails?.reels || 0;
    const symbols = gameSettings?.slotSymbols || [];
    const paylines = gameSettings?.slotConfigDetails?.paylines?.length || 0;
    const balanceForConfig = gameSettings?.balance || 0;
    const line = gameSettings?.slotConfigDetails?.paylines.length || 0

    const gameBackgroundUrl = gameSettings?.slotConfigDetails?.game_background_url || "/game-bg.png"
    const navbarBackgroundUrl = gameSettings?.slotConfigDetails?.navbar_background_url || '/navbar-background.png'
    const spinButtonUrl = gameSettings?.slotConfigDetails?.spin_button_url || "/spin.png"
    const autoPlayButtonUrl = gameSettings?.slotConfigDetails?.autoPlay_button_url || "/autoPlay.png"
    const plusButtonUrl = gameSettings?.slotConfigDetails?.plus_button_url || "/plus.png"
    const minusButtonUrl = gameSettings?.slotConfigDetails?.minus_button_url || "/minus.png"
    const payLinesButtonUrl = gameSettings?.slotConfigDetails?.payLines_button_url || "/lines.png"
    const turboButtonUrl = gameSettings?.slotConfigDetails?.turbo_button_url || "/turbo.png"
    const turboOnButtonUrl = gameSettings?.slotConfigDetails?.turbo_on_button_url || "/turbo-on.png"
    const settingsButtonUrl = gameSettings?.slotConfigDetails?.settings_button_url || "/settings.png"
    const soundButtonUrl = gameSettings?.slotConfigDetails?.sound_button_url || "/volume-high.png"
    const infoButtonUrl = gameSettings?.slotConfigDetails?.info_button_url || "/info.png"

    const baseAudioUrl = gameSettings?.slotConfigDetails?.base_audio_url || "/game-background-music.mp3"
    const normalButtonAudioUrl = gameSettings?.slotConfigDetails?.normal_button_audio_url || "/normal_button.mp3"
    const reelStopAudioUrl = gameSettings?.slotConfigDetails?.reel_stop_audio_url || "/reel_stop.mp3"
    const turboReelStopAudioUrl = gameSettings?.slotConfigDetails?.turbo_reel_stop_audio_url || "/turbo_reel_stop.mp3"
    const bonusAudioUrl = gameSettings?.slotConfigDetails?.bonus_audio_url || "/bonus.mp3"
    const wildAudioUrl = gameSettings?.slotConfigDetails?.wild_audio_url || "/wild.mp3"
    const featureWinAudioUrl = gameSettings?.slotConfigDetails?.feature_win_audio_url || "/feature_win.mp3"
    const totalWinAudioUrl = gameSettings?.slotConfigDetails?.total_win_audio_url || "/total_win.mp3"

    const jackpotDetailAvailable = !!gameSettings?.jackpotDetail;
    const grandJackpotAmount = gameSettings?.jackpotDetail?.levels_trigger_prize?.filter((val) => val.level === "Platinum")[0]?.prize_value
    const miniJackpotAmount = gameSettings?.jackpotDetail?.levels_trigger_prize?.filter((val) => val.level === "Bronze")[0]?.prize_value
    const majorJackpotAmount = gameSettings?.jackpotDetail?.levels_trigger_prize?.filter((val) => val.level === "Gold")[0]?.prize_value
    const minorJackpotAmount = gameSettings?.jackpotDetail?.levels_trigger_prize?.filter((val) => val.level === "Silver")[0]?.prize_value

    const minBet = gameSettings?.slotEngineDetails?.min_bet || 0
    const maxBet = gameSettings?.slotEngineDetails?.max_bet || 0

    const scatterTriggerConfig = gameSettings?.slotEngineDetails?.scatter_trigger_config || {}

    // Function to generate random symbols based on lines & reels
    const generateRandomSymbols = () => {
        return Array.from({ length: lines }, () =>
            Array.from({ length: reels }, () => symbols[Math.floor(Math.random() * symbols.length)])
        );
    };

    const generateOrderedSymbols = () => {
        let index = 0;
        return Array.from({ length: lines }, () =>
            Array.from({ length: reels }, () => {
                const symbol = symbols[index % symbols.length];
                index++;
                return symbol;
            })
        );
    };

    return {
        lines,
        reels,
        symbols,
        generateRandomSymbols,
        generateOrderedSymbols,
        paylines,
        balanceForConfig,
        line,
        gameBackgroundUrl,
        navbarBackgroundUrl,
        spinButtonUrl,
        autoPlayButtonUrl,
        plusButtonUrl,
        minusButtonUrl,
        payLinesButtonUrl,
        turboButtonUrl,
        turboOnButtonUrl,
        settingsButtonUrl,
        soundButtonUrl,
        infoButtonUrl,
        baseAudioUrl,
        normalButtonAudioUrl,
        reelStopAudioUrl,
        turboReelStopAudioUrl,
        bonusAudioUrl,
        wildAudioUrl,
        featureWinAudioUrl,
        totalWinAudioUrl,
        grandJackpotAmount,
        miniJackpotAmount,
        minorJackpotAmount,
        majorJackpotAmount,
        jackpotDetailAvailable,
        minBet,
        maxBet,
        scatterTriggerConfig
    };
};

export { useGameSettings };
